export const KEY_PATH_SUFFIX = [
  'value',
  'formattedValue',
  'ft_value',
  'ft_text',
  'ft_search',
  'ftListValue',
  'ftListLabel',
  'VALUE_STEP',
  'url',
  'type',
  'IMG_SRC',
  'IMG_HOV_SRC',
  'IMG_CLK_SRC',
  'BTN_TEXT',
  'TYPO_TEXT',
  'text',
  'href',
  'target',
  'x',
  'y',
  'r',
  'label',
  'selectedItems',
  'selectedGroupItems',
  'groupText',
  'groupValue',
  'groupIcon',
  'original',
  'originalAlt',
  'originalTitle',
  'description',
  'fullscreen',
  'thumbnail',
  'thumbnailLabel',
  'thumbnailTitle',
  'thumbnailAlt',
  'caption',
]

const KeySuffixRe = new RegExp(KEY_PATH_SUFFIX.map((v) => `(\:${v})$`).join('|'))
export const trimKeySuffix = (str) =>
  String(str)
    .replace(KeySuffixRe, '')
    .replace(/(:[\d]*$)/, '')
